export default __webpack_public_path__ + "static/team3-f0962cc407c10793dd0139c3be998adf.jpg";